import { useDispatch, useSelector } from "react-redux";

import { CreateVideo } from "../../redux/videos";
import { ErrorBanner } from "../../components/banner";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { VideoForm } from "./VideoForm";
import { useNavigate } from "react-router-dom";

export const VideoCreate = () => {
  const { loading, error } = useSelector((state) => state.videos);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to save?`)) {
      dispatch(CreateVideo(values));
    }

    if (!loading) {
      setTimeout(() => {
        navigate("/gallery/videos");
      }, 500);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Section>
        {error && <ErrorBanner text={error} />}

        <VideoForm onFormSubmit={onFormSubmit} />
      </Section>
    </>
  );
};
